import $ from 'jquery';
import {is_function} from '../../../Helpers/js/simple.functions';
import LP from '../0-lp';
import UI from '../0-ui';


//=============== //
//QUESTION WIZARD //
//=============== //
LP.dlgQuestionWizard = {
    position: 0,
    wizardDlg: null,
    reloading: false,
    prevPlaceholder: '',
    suspendPlaceholder: false,
    orgAfterSubmit: null,
    orgBeforeSubmit: null,
    initEvents: new Array(), // Event-Handlers for init of previews

    prepare: function (selector, params) {
        LP.dlgQuestionWizard.orgAfterSubmit = params.afterSubmit;
        LP.dlgQuestionWizard.orgBeforeSubmit = params.beforeSubmit;

        $(selector).click(function () {
            if (!$(this).is('[disabled]')) {
                LP.dlgQuestionWizard.wizardDlg = LP.Dialog.open($.extend(params, {
                    name: 'questionWizard',
                    ajax: $(this).attr('url'),
                    request: $(this).attr('url_params'),
                    title: this.title,
                    width: 1000,
                    height: 600,
                    sizeable: false,
                    onLoad: LP.dlgQuestionWizard.onLoad,
                    beforeSubmit: LP.dlgQuestionWizard.beforeSubmit,
                    afterSubmit: LP.dlgQuestionWizard.afterSubmit,
                    onClose: LP.dlgQuestionWizard.onClose
                }));
            }
            return false;
        });
    },

    onLoad: function () {
        LP.dlgQuestionWizard.reloading = false;

        var questionTypeChooser = $('#lp-questiontype-chooser');
        questionTypeChooser.accordion({change: LP.dlgQuestionWizard.selectCategory});
        $('a.lp-question-template', questionTypeChooser).click(LP.dlgQuestionWizard.selectTemplate);

        var preview = $('#lp-preview');
        UI.triggerEvent('onInit', preview);
        UI.triggerEvent('onShow', preview);

        LP.dlgQuestionWizard.selectCategory();

        $('#isDuty').click(function () {
            LP.dlgQuestionWizard.updateDuty();
        });
        $('#notDuty').click(function () {
            LP.dlgQuestionWizard.updateDuty();
        });

        $('.choicetype_button').click(function () {
            LP.dlgQuestionWizard.updatePreview($(this).val(), $('.choicedir_button:checked').val());
        });
        $('.choicedir_button').click(function () {
            LP.dlgQuestionWizard.updatePreview($('.choicetype_button:checked').val(), $(this).val());
        });
        $('.scaletype_button').click(function () {
            LP.dlgQuestionWizard.updatePreview($(this).val(), 0);
        });
        $('.inputtype_button').click(function () {
            LP.dlgQuestionWizard.updatePreview($(this).val(), 0);
        });
        $('.inputdir_button').click(function () {
            LP.dlgQuestionWizard.updatePreview($(this).val(), $('.inputdir_button:checked').val());
        });
    },

    onClose: function () {
        var wizard = $('#wizardtexteditor');
        window.Browser.send('backend/closeQuestionWizard/');

        wizard.empty();
        return false;
    },

    beforeSubmit: function (json) {
        const content = $('#froala').find('.fr-view').html();
        $('#wizardtexteditor').val(content);

        if (LP.dlgQuestionWizard.orgBeforeSubmit) {
            LP.dlgQuestionWizard.orgBeforeSubmit(json);
        }
        return true;
    },

    afterSubmit: function (json) {
        if (LP.dlgQuestionWizard.orgAfterSubmit) {
            LP.dlgQuestionWizard.orgAfterSubmit(json);
        }
        return true;
    },

    addInitEvent: function (id, callback) {
        LP.dlgQuestionWizard.initEvents.push({
            id: id,
            event: callback
        });
    },

    callInitEvents: function (id) {
        var numEvents = LP.dlgQuestionWizard.initEvents.length;
        for (var i = 0; i < numEvents; i++) {
            if (i in LP.dlgQuestionWizard.initEvents &&
                (!LP.dlgQuestionWizard.initEvents[i].id || LP.dlgQuestionWizard.initEvents[i].id === id) &&
                is_function(LP.dlgQuestionWizard.initEvents[i].event)) {
                LP.dlgQuestionWizard.initEvents[i].event();
            }
        }
    },

    selectCategory: function () {
        if (LP.dlgQuestionWizard.reloading) {
            return false;
        }

        var typeChooser = $('#lp-questiontype-chooser');
        var category = $('.active.title', typeChooser);

        var templates = category.next().find('a.lp-question-template');
        templates.first().click();
    },

    selectTemplate: function () {
        if (LP.dlgQuestionWizard.reloading) {
            return false;
        }
        var typeChooser = $('#lp-questiontype-chooser');
        var selectedLink = $(this);
        if (selectedLink.hasClass('lp-selected')) {
            return;
        }
        $('a.lp-selected', typeChooser).removeClass('lp-selected');

        selectedLink.addClass('lp-selected');
        $('#questionTemplate').val(selectedLink.attr('template'));
        LP.dlgQuestionWizard.loadTemplate(selectedLink.attr('template'), selectedLink.attr('type'));
        return false;
    },

    preloadTemplate: function (name, type, onLoad) {
        var templateCache = $('#lp-template-cache');
        var templatePreview = $('[template="' + name + '"]', templateCache);
        var typeChooser = $('#lp-questiontype-chooser');

        if (templatePreview.html().length === 0) {
            LP.dlgQuestionWizard.reloading = true;

            var category = $('.active.title', typeChooser);
            var catagoryParams = {
                poll: category.attr('poll'),
                page: category.attr('page'),
                group: category.attr('category')
            };

            $('#lp-preview').html($('#ui-dialog-loader').html());

            window.Browser.send('/backend/getTemplateGroup/', $.param(catagoryParams), function (json) {
                for (var templateName in json.previews) {
                    var templatePreview2 = $('[template="' + templateName + '"]', templateCache);
                    var jsonPreview = json.previews[templateName];
                    templatePreview2.html(jsonPreview);
                    UI.triggerEvent('onInit', templatePreview2);
                    UI.triggerEvent('onShow', templatePreview2);

                }
                if (is_function(onLoad)) {
                    onLoad(name, type);
                }
                LP.dlgQuestionWizard.reloading = false;
            });
        } else if (is_function(onLoad)) {
            onLoad(name, type);
        }
    },

    loadTemplate: function (name, type) {
        LP.dlgQuestionWizard.preloadTemplate(name, type, LP.dlgQuestionWizard.showTemplate);
        return false;
    },

    showTemplate: function (name, type) {
        var templateCache = $('#lp-template-cache');
        var cachedPreview = $('[template="' + name + '"]', templateCache);
        var templateDef = $('li a[template="' + name + '"]');

        var preview = $('#lp-preview');
        templateCache.append(preview.children());
        preview.append(cachedPreview);

        preview.attr('tpl', name);

        window.Browser.send('backend/showTemplate/', 'name=' + name + '&poll=' + $('#pollId').val());
        LP.dlgQuestionWizard.setupPreview();

        var questionPreview = $('#lp-question-preview');
        var textblockPreview = $('#lp-textblock-preview');
        var resultviewPreview = $('#lp-resultview-preview');
        var questionSettings = $('#lp-question-settings');
        var resultviewSettings = $('#lp-resultview-settings');

        questionPreview.hide();
        textblockPreview.hide();
        resultviewPreview.hide();
        questionSettings.hide();
        resultviewSettings.hide();

        if (type === 'TEXT') {
            LP.dlgQuestionWizard.setupTextPreview(preview);
            textblockPreview.show();
        } else if (type === 'RESULT') {
            LP.dlgQuestionWizard.setupResultPreview(preview);
            resultviewPreview.show();
            resultviewSettings.show();

            LP.UI.jQPlot.loadCharts();

        } else {
            var changeable = templateDef.attr('changeable');
            LP.dlgQuestionWizard.setupQuestionPreview(preview, type, changeable);
            questionPreview.show();
            questionSettings.show();
        }

        LP.dlgQuestionWizard.suspendPlaceholder = false;
    },

    setupTextPreview: function (preview) {
        var $pretext = $('.lp-ps-textblock', preview);
        const froalaDiv = document.getElementById('froala');
        froalaDiv.setAttribute('data-html', $pretext.html());
        window.reactPortals.addPollTextEditor(froalaDiv);
    },

    setupResultPreview: function () {
        LP.pollResultsCharts.initChart('#lp-resultview-preview');
    },

    setupQuestionPreview: function (preview, type, changeable) {
        if (type === 'SINGLECHOICE2' || type === 'MULTICHOICE2') {
            LP.dlgQuestionWizard.unlockPreview();
        } else {
            LP.dlgQuestionWizard.lockPreview();
        }

        $('#choiceType').hide();
        $('#choiceDirection').hide();
        $('#captchaType').hide();
        $('#scaleType').hide();
        $('#inputType').hide();
        $('#inputDir').hide();

        if (type === 'SINGLECHOICE' || type === 'SINGLECHOICE2' || type === 'SINGLECHOICE_H') {
            LP.dlgQuestionWizard.setupChoiceQuestion(type, changeable);
        } else if (type === 'MULTICHOICE' || type === 'MULTICHOICE2' || type === 'MULTICHOICE_H') {
            LP.dlgQuestionWizard.setupChoiceQuestion(type, changeable);
        } else if (type === 'SCALE' || type === 'CHOICESCALE' || type === 'SLIDERSCALE' || type === 'SPINSCALE' || type === 'STARSCALE' || type === 'NPS_SCALE' || type === 'CES_SCALE') {
            LP.dlgQuestionWizard.setupScaleQuestion(type, changeable);
        } else if (type === 'INPUT' || type === 'CAPTCHINPUT' || type === 'UPLOADINPUT') {
            LP.dlgQuestionWizard.setupInputQuestion(type, changeable);
        } else if (type === 'MATRIX') {
            LP.dlgQuestionWizard.setupMatrixQuestion(type, changeable);
        } else if (type === 'RANKING') {
            LP.dlgQuestionWizard.setupRankingQuestion(type, changeable);
        }
        // eslint-disable-next-line no-undef
        else if ($type === 'TEXT') { /* empty */
        }
        // eslint-disable-next-line no-undef
        else if ($type === 'RESULT') { /* empty */
        }

        UI.triggerEvent('onShow', $('#lp-preview'));
    },

    setupChoiceQuestion: function (type, changeable) {
        if (!changeable) {
            return;
        }

        var hasTypeChangeable = changeable.indexOf('S') !== -1 || changeable.indexOf('M') !== -1 || changeable.indexOf('D') !== -1 || changeable.indexOf('L') !== -1;
        var hasDirChangeable = changeable.indexOf('V') !== -1 || changeable.indexOf('H') !== -1;

        if (hasTypeChangeable) {
            $('#choiceType').show();
        } else {
            $('#choiceType').hide();
        }
        if (hasDirChangeable) {
            $('#choiceDirection').show();
        } else {
            $('#choiceDirection').hide();
        }

        if (type === 'SINGLECHOICE') {
            $('#choicetype_single').prop('checked', true);
        } else if (type === 'SINGLECHOICE2') {
            $('#choicetype_drop').prop('checked', true);
        } else if (type === 'MULTICHOICE') {
            $('#choicetype_multi').prop('checked', true);
        } else if (type === 'MULTICHOICE2') {
            $('#choicetype_list').prop('checked', true);
        }

        if (hasTypeChangeable) {
            if (changeable.indexOf('S') === -1) {
                $('#choicetype_single_option').hide();
            } else {
                $('#choicetype_single_option').show();
            }
            if (changeable.indexOf('M') === -1) {
                $('#choicetype_multi_option').hide();
            } else {
                $('#choicetype_multi_option').show();
            }
            if (changeable.indexOf('D') === -1) {
                $('#choicetype_dropdown_option').hide();
            } else {
                $('#choicetype_dropdown_option').show();
            }
            if (changeable.indexOf('L') === -1) {
                $('#choicetype_list_option').hide();
            } else {
                $('#choicetype_list_option').show();
            }
        }

        if (hasDirChangeable) {
            if (type === 'SINGLECHOICE_H' || type === 'MULTICHOICE_H') {
                $('#choicedir_horizontal').prop('checked', true);
            } else {
                $('#choicedir_vertical').prop('checked', true);
            }
            if (changeable.indexOf('V') === -1) {
                $('#choicedir_vertical_option').hide();
            } else {
                $('#choicedir_vertical_option').show();
            }
            if (changeable.indexOf('H') === -1) {
                $('#choicedir_horizontal_option').hide();
            } else {
                $('#choicedir_horizontal_option').show();
            }
        } else {
            $('.choicedir_button').prop('checked', false);
        }
    },

    setupScaleQuestion: function (type, changeable) {
        if (!changeable) {
            return;
        }

        $('#scaleType').show();

        if (type === 'CHOICESCALE' || type === 'SCALE') {
            $('#scaletype_choice').prop('checked', true);
        } else if (type === 'SLIDERSCALE') {
            $('#scaletype_slider').prop('checked', true);
        } else if (type === 'SPINSCALE') {
            $('#scaletype_spin').prop('checked', true);
        } else if (type === 'STARSCALE') {
            $('#scaletype_star').prop('checked', true);
        }

        if (changeable.indexOf('C') === -1) {
            $('#scaletype_choice_option').hide();
        } else {
            $('#scaletype_choice_option').show();
        }
        if (changeable.indexOf('I') === -1) {
            $('#scaletype_slider_option').hide();
        } else {
            $('#scaletype_slider_option').show();
        }
        if (changeable.indexOf('B') === -1) {
            $('#scaletype_spin_option').hide();
        } else {
            $('#scaletype_spin_option').show();
        }
        if (changeable.indexOf('S') === -1) {
            $('#scaletype_star_option').hide();
        } else {
            $('#scaletype_star_option').show();
        }
    },

    setupInputQuestion: function (type, changeable) {
        if (changeable) {

            if (changeable === 'CAPTCHA') {
                $('#captchaType').show();
                $('#inputType').hide();
                $('#inputDir').hide();
            } else {
                $('#captchaType').hide();

                var hastype = false;
                if (changeable.indexOf('S') === -1) {
                    $('#inputype_single_option').hide();
                } else {
                    hastype = true;
                    $('#inputype_single_option').show();
                    $('#inputype_single_option input').prop('checked', true);
                }
                if (changeable.indexOf('M') === -1) {
                    $('#inputype_multi_option').hide();
                } else {
                    hastype = true;
                    $('#inputype_multi_option').show();
                }

                if (changeable.indexOf('N') === -1) {
                    $('#inputype_int_option').hide();
                } else {
                    hastype = true;
                    $('#inputype_int_option').show();
                    $('#inputype_int_option input').prop('checked', true);
                }
                if (changeable.indexOf('F') === -1) {
                    $('#inputype_float_option').hide();
                } else {
                    hastype = true;
                    $('#inputype_float_option').show();
                }

                if (changeable.indexOf('D') === -1) {
                    $('#inputype_date_option').hide();
                } else {
                    hastype = true;
                    $('#inputype_date_option').show();
                    $('#inputype_date_option input').prop('checked', true);
                }
                if (changeable.indexOf('T') === -1) {
                    $('#inputype_time_option').hide();
                } else {
                    hastype = true;
                    $('#inputype_time_option').show();
                }

                if (hastype) {
                    $('#inputType').show();
                }

                if (changeable.indexOf('V') !== -1 || changeable.indexOf('H') !== -1) {
                    $('#inputDir').show();
                }
            }
        }
    },

    setupMatrixQuestion: function () {
        //if (!changeable) return;
    },

    setupRankingQuestion: function () {
        // if (!changeable) return;
    },

    isDuty: function () {
        if ($('#isDuty').is(':checked')) {
            return true;
        }
        return false;
    },

    updateDuty: function () {
        const $preview = $('#lp-preview');
        const theme = $('#lp-question-preview').find('#theme').val();

        const $questionText = $('.question-text', $preview);
        const $questionTextContainer = $('.question-text-container', $preview);
        const isDuty = LP.dlgQuestionWizard.isDuty();

        if (theme === 'default4') {
            var hasMarker = $('.duty-marker', $preview).length > 0;
            if (isDuty && !hasMarker) {
                $questionTextContainer.prepend($('<span class="icon-star-4 duty-marker" />'));
            } else if (!isDuty && hasMarker) {
                $('.duty-marker').remove();
            }
        } else if (theme === 'thV5') {
            if (isDuty) {
                $questionText.find('span').addClass('duty-question-title');
            } else {
                $questionText.find('span').removeClass('duty-question-title');
            }
        }
    },

    updateText: function () {
        LP.dlgQuestionWizard.updateDuty();
    },

    updatePreview: function (type, dir) {
        var $preview = $('#lp-preview');

        var selected = $('a.lp-selected', '#lp-questiontype-chooser');

        var template = $preview.find('div[template]');

        var templateURL = template.attr('url');
        var templateParams = template.attr('url_params');
        if (type) {
            templateParams += '&type=' + type;
        }
        if (dir) {
            templateParams += '&dir=' + dir;
        }
        if (type === 'SINGLECHOICE' || type === 'MULTICHOICE') {
            if (dir === 'H') {
                type = type + '_H';
            } else {
                type = type;
            }
            selected.attr('type', type);
        }

        window.Browser.send(templateURL, templateParams, function (json) {
            LP.dlgQuestionWizard.setupPreview(json.html);

            if (type === 'SINGLECHOICE2' || type === 'MULTICHOICE2') {
                LP.dlgQuestionWizard.unlockPreview();
            } else {
                LP.dlgQuestionWizard.lockPreview();
            }

            LP.dlgQuestionWizard.unlockPreview();
        });
    },

    setupPreview: function (html) {
        var preview = $('#lp-preview');
        if (html) {
            preview.find('div[template]').html(html);
        }
        UI.triggerEvent('onInit', preview);
        UI.triggerEvent('onShow', preview);

        // Change all ids for label/input referented
        var changedIds = new Array();
        preview.find('label[for]').each(function () {
            $(this).attr('for', $(this).attr('for') + 'X');
        });
        preview.find('*[id]').each(function () {
            changedIds.push({id: '#' + $(this).attr('id')});
            $(this).attr('id', $(this).attr('id') + 'X');
        });

        // Call event hooks for ids
        for (var i = 0; i < changedIds.length; i++) {
            if (i in changedIds) {
                LP.dlgQuestionWizard.callInitEvents(changedIds[i].id);
            }
        }
        LP.dlgQuestionWizard.updateDuty();
    },

    lockPreview: function () {
        $('#lp-preview-overlay').css('pointer-events', 'none');
    },
    unlockPreview: function () {
        $('#lp-preview-overlay').css('pointer-events', 'auto');
    }

};